<template>
  <b-container fluid class="marketplace-container">
    <div class="position-relative content-div">
      <HeaderNavBar :menuItems="menuItems"/>
      <SideBar />
      <Showcase />
      <CategoriesCards />
      <PopularFormulasCards />
      <div class="child-footer">
        <MarketplaceFooter />
      </div>
    </div>
  </b-container>
</template>

<script>
import HeaderNavBar from "@/components/marketplace/HeaderNavBar.vue";
import Showcase from "@/components/marketplace/Showcase.vue";
import CategoriesCards from "@/components/marketplace/CategoriesCards.vue";
import PopularFormulasCards from "@/components/marketplace/PopularFormulasCards.vue";
import MarketplaceFooter from "@/components/marketplace/MarketplaceFooter.vue";
import SideBar from "@/components/marketplace/SideBar.vue";


export default {
  title: "Dropsmart Marketplace",
  name: "DropsmartMarketplace",
  components: {
    HeaderNavBar,
    Showcase,
    CategoriesCards,
    PopularFormulasCards,
    MarketplaceFooter,
    SideBar,
  },
  data() {
    return {
      content: null,
      customerInfo: null,
      menuItems: ["Perks", "App", "Academy", "Premium", "Free", "Referral"],
    };
  },
};
</script>

<style lang="scss">
/* ====GENERAL================================================== */
html,
body,
#app {
  height: 100%;
}
/* ====Hide toolbar============================================= */
body::-webkit-scrollbar {
  display: none;
}
html {
  scrollbar-width: none;
}

</style>

<style scoped lang="scss">
$bg-gray: #f7f7f7;
$bg-footer-dark-gray: #d9d9d9;

main {
  overflow-x: hidden;
  height: 100%;
}

.marketplace-container {
  margin-top: 1rem;
  justify-content: center;
  display: flex;
}

.content-div {
  max-width: 1000px;
}

.child-footer {
  width: 100vw;
  //margin: auto;
  position: relative;
  left: calc(-50vw + 50%);

  background-color: $bg-footer-dark-gray;

  margin-top: 5rem;
}

@media screen and (max-width: 1023px) {
  .marketplace-container {
    display: block;
  }
}
</style>
